module.exports = __webpack_public_path__ + "img/post_3.7aab867b.jpg";